import { render, staticRenderFns } from "./CarrotDownWide.vue?vue&type=template&id=e5ed95a0&scoped=true&"
import script from "./CarrotDownWide.vue?vue&type=script&lang=js&"
export * from "./CarrotDownWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ed95a0",
  null
  
)

export default component.exports